module.exports = __webpack_public_path__ + "img/favicon.c4908538.png";